<button 
    gaEvent
    gaAction="Clicked View Menu"
    data-test="viewMenu"
    [matMenuTriggerFor]="viewMenu"
    matTooltip="Menu"
    app-pin-button
    buttonType="secondary"
    icon="bars"
    [fill]="true"
    style="width: 52px; height: 52px"
    aria-label="View Menu"
></button>
  
<!-- More Menu -->
<mat-menu #viewMenu="matMenu" gaCategory="View Menu" class="view-menu">
  <!-- Search -->
  <button 
    gaEvent
    gaAction="Clicked Open Search"
    *ngIf="isEnabled(viewUI.Search)"
    mat-menu-item
    (click)="handleSearchClick()"
    data-test="viewSearchButton">
    <app-icon class="view-menu__icon" icon="search"></app-icon>
    <span class="ml-2">Search</span>
  </button>

  <!-- Visibility Layers -->
  <button
    *ngIf="visibilityLayersVisible"
    mat-menu-item
    (click)="toggleToolbar('visibilityLayers')">
    <app-icon class="view-menu__icon" icon="layer-group"></app-icon>
    <span class="ml-2">Layers</span>
  </button>

  <!-- Tools -->
  <button 
    gaEvent
    gaAction="Clicked Open Explore Tools"
    *ngIf="isEnabled(viewUI.Tools)"
    mat-menu-item
    (click)="toggleToolbar('tools')"
    data-test="viewToolsButton">
    <app-icon class="view-menu__icon" icon="mouse-pointer"></app-icon>
    <span class="ml-2">Explore</span>
  </button>

  <!-- Whiteboard -->
  <button
    gaEvent
    gaAction="Clicked Open Whiteboard"
    *ngIf="isEnabled(viewUI.Whiteboard)"
    mat-menu-item
    (click)="handleDrawClick()"
    [disabled]="!(selectedChapterReady$ | async)?.model"
    data-test="viewDrawButton">
    <app-icon class="view-menu__icon" icon="signature"></app-icon> 
    <span class="ml-2">Draw</span>
  </button>

  <button
    *ngIf="(hasQuiz$ | async) && (quizEnabled$ | async) && !(quizLocked$ | async)"
    mat-menu-item
    [disabled]="!(selectedChapterReady$ | async)?.model || (quizActive$ | async)"
    (click)="handleTakeQuizClick()"
    data-test="viewQuizButton">
    <app-icon class="view-menu__icon" icon="check"></app-icon> 
    <span class="ml-2">Take Quiz</span>
  </button>


  <!-- Fullscreen -->
  <ng-container *ngIf="isEnabled(viewUI.Fullscreen)">
    <mat-divider></mat-divider>

    <!-- Fullscreen -->
    <button
      *ngIf="canFullscreen"
      mat-menu-item
      (click)="handleFullscreenClick()">
      <ng-container *ngIf="isFullscreen">Exit Fullscreen</ng-container>
      <ng-container *ngIf="!isFullscreen">Enter Fullscreen</ng-container>
    </button>

    <!-- Open in new tab -->
    <ng-container *appFlagApplication="application.All; mode:'exclude', native: nativePlatform.All">

      <button
        *ngIf="!canFullscreen"
        mat-menu-item
        (click)="handleNewTabClick()">
        Open in New Tab
      </button>

    </ng-container>

  </ng-container>

  <button 
    *ngIf="isEnabled(viewUI.ToggleLabels)"
    mat-menu-item 
    (click)="handleToggleLabelsClick()"
    data-test="viewToggleLabels">
      <span class="mr-3">Toggle Labels</span>
      <span *ngIf="showLabels$ | async" class="text-dim">(On)</span>
      <span *ngIf="!(showLabels$ | async)" class="text-dim">(Off)</span>
  </button>

  <mat-divider></mat-divider>

  <!-- Help -->
  <button
    mat-menu-item
    *ngIf="isEnabled(viewUI.Help)"
    [matMenuTriggerFor]="helpMenu">
    Help
  </button>

</mat-menu>

<!-- Help menu -->
<mat-menu #helpMenu="matMenu" gaCategory="View Menu">
  <button 
    gaEvent
    gaAction="Clicked Launch Tutorial"
    mat-menu-item
    (click)="handleTutorialClick()"
    [disabled]="!(selectedChapterReady$ | async)?.model">
    Launch Tutorial
  </button>

  <button
    gaEvent
    gaAction="Clicked 3d Navigation Basics"
    mat-menu-item
    (click)="handleHelpBasicsClick()">3D Navigation Basics</button>
  
  <button
    gaEvent
    gaAction="Clicked Keyboard Shortcuts"
    mat-menu-item
    (click)="handleHelpShortcutsClick()">Keyboard Shortcuts</button>
</mat-menu>

